import { t } from "i18next";
import mailValidate from "../../shared/mail.validate";
import passwordLengthValidate from "../../shared/passwordLength.validate";

export type TErrors = {
  email: string | undefined;
  password: string | undefined;
};

const loginValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = { email: undefined, password: undefined };

  errors.email = mailValidate(FormValues.email);

  errors.password = passwordLengthValidate(
    FormValues.password,
    t("core:common:password")
  );

  return errors;
};

export default loginValidate;
